import { Navigate } from "react-router-dom";
import { isLogIn } from "./config/Apis";

export default function PublicRoute({ children }) {
  const { isToken } = isLogIn();

  if (isToken) {
    return <Navigate to="/" replace />;
  }

  return children;
}
